import { render, staticRenderFns } from "./bannerMenuNew.vue?vue&type=template&id=5e53cec6&scoped=true"
import script from "./bannerMenuNew.vue?vue&type=script&lang=js"
export * from "./bannerMenuNew.vue?vue&type=script&lang=js"
import style0 from "./bannerMenuNew.vue?vue&type=style&index=0&id=5e53cec6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e53cec6",
  null
  
)

export default component.exports